import { sendEvent } from './sendEvent'

type ShareType =
  | 'guest_invite'
  | 'member_invite'
  | 'public_map'
  | 'embed_code'
  | 'info_graphic'
  | 'member_invite_link'

export function mapSharedEvent(shareType: ShareType) {
  sendEvent('event', 'map_shared', {
    share_type: shareType
  })
}
